import { BASE_URL_SANCTUM } from './misc/consts';

export const stopScrolling = () => {
  document.body.classList.add('stop-scrolling');
};

export const startScrolling = () =>
  document.body.classList.remove('stop-scrolling');

export const getXsfrToken = async () => {
  const response = await fetch(BASE_URL_SANCTUM);
  if (!response.ok) {
    throw new Error(`Error! status: ${response.status}`);
  }
};
